import { useMutation } from "@tanstack/react-query";
import type { StorefrontLinkDefaultGetResponseType } from "@sellar-io/api-v2/types";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useSupplierDefaultStorefrontLink = () => {
  return useMutation({
    mutationFn: (supplierUrlId: string) =>
      apiV2Request({
        user: undefined,
        business: null,
        method: "get",
        path: `storefront-link/default/${supplierUrlId}`,
      }).then(
        (response) =>
          apiV2AssertResponse<StorefrontLinkDefaultGetResponseType>(response)
            .data,
      ),
  });
};
